import { render, staticRenderFns } from "./ChooseReinvestmentAmount.vue?vue&type=template&id=50da26ae&scoped=true"
import script from "./ChooseReinvestmentAmount.vue?vue&type=script&lang=js"
export * from "./ChooseReinvestmentAmount.vue?vue&type=script&lang=js"
import style0 from "./ChooseReinvestmentAmount.vue?vue&type=style&index=0&id=50da26ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50da26ae",
  null
  
)

export default component.exports